<template>
  <div>
    <bs-card class="card-info" :icon="icon" :label="labels.name">
      <template v-slot:header>
      </template>
      <bs-table v-bind="{dataLength, loading}" :cols="2">
        <template v-slot:thead>
          <tr>
            <th scope="col">{{ $t('labels.name') }}</th>
            <th scope="col" class="text-right">{{ $t('labels.reserved') }}</th>
          </tr>
        </template>
        <tr v-for="r in resources.data" :key="r.id">
          <td>{{ r.label }}</td>
          <td class="text-right">{{ $n(r.reserved, 'currency') }}</td>
        </tr>
        <template v-slot:tfoot>
          <pagination :data="resources" :state="resourceState" :counts="[10, 15, 20, 50]" @pushPage="index"></pagination>
        </template>
      </bs-table>
    </bs-card>
    <bs-modal :name="'create-' + $options.name" :label="resource.id ? labels.edit : labels.create">
      <bs-form :submit="$t('labels.submit')" @submit="submit">
        <template v-slot:default="slotProps">
          <input-field :name="'name'" :label="$t('labels.name')" v-model="resource.name" :error="slotProps.error"></input-field>
        </template>
      </bs-form>
    </bs-modal>
    <bs-modal :name="'destroy-' + $options.name" :label="labels.delete">
      <bs-form :destroy="$t('labels.destroy')" @submit="destruction">
        {{ $t('messages.delete', { resource: camelToSpace(singular($options.name)) }) }}
      </bs-form>
    </bs-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { resourceControl } from '../../mixins/resourceControl'

export default {
  name: 'FundBalances',
  mixins: [resourceControl],
  data () {
    return {
      icon: ['fal', 'piggy-bank'],
      resource: {
        name: ''
      }
    }
  },
  computed: {
    ...mapState({
      resources: state => state.fundBalances,
      resourceState: state => state.fundBalancesState
    })
  }
}
</script>
